/* eslint-disable no-console */
// eslint-disable-next-line import/no-extraneous-dependencies
import { jwtDecode } from 'jwt-decode'
import { ToastOptions, toast } from 'react-toastify'
import { getToken, messaging } from 'config/firebase'

export const decodeToken = (token: string): Record<string, any> | null => {
  try {
    return jwtDecode(token)
  } catch (error) {
    return null
  }
}

export const isTokenExpired = (token: string): boolean => {
  const decoded = decodeToken(token)
  if (!decoded || !decoded.exp) return true
  const currentTime = Date.now() / 1000
  return decoded.exp < currentTime
}

export const notifySuccess = (message: string) => toast.success(message)
export const notifyInfo = (
  message: string | JSX.Element,
  options?: ToastOptions<unknown> | undefined
) =>
  toast.info(message, {
    ...options,
    containerId: options?.containerId ?? 'default',
    autoClose: 3000
  })
export const notifyWarning = (message: string) => toast.warning(message)
export const notifyError = (
  message: string | JSX.Element,
  options?: ToastOptions<unknown> | undefined
) =>
  toast.error(message, {
    ...options,
    containerId: options?.containerId ?? 'default',
    autoClose: 3000
  })
export interface FileObject {
  blobFile: File;
  name: string;
  status: string;
  fileKey: string;
}
export function isFileObject(value: any): value is FileObject {
  return value && typeof value === 'object' && 'blobFile' in value
}

export function previewFile(
  file: Blob | undefined,
  callback: { (value: any): void, (arg0: string | ArrayBuffer | null): void }
) {
  const reader = new FileReader()
  reader.onloadend = () => {
    callback(reader.result)
  }
  if (file) {
    reader.readAsDataURL(file)
  }
}

export const getModalTitleText = (isLoading: boolean, exp?: any): string => {
  if (!isLoading) {
    return exp || ''
  }
  return ''
}

export const toDropdownOptions = <T, V = string>({
  data,
  valueKey,
  labelKey
}: {
  data: T[],
  valueKey?: keyof T,
  labelKey?: keyof T
}): { value: V, label: string }[] => {
  return data.map((item) => {
    const value: V = valueKey
      ? (item[valueKey] as unknown as V)
      : (String(item) as V)
    const label = labelKey ? String(item[labelKey]) : String(item)
    return {
      value,
      label
    }
  })
}

export const requestNotificationPermission = async (): Promise<
  string | null
> => {
  try {
    const permission = await Notification.requestPermission()

    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_ID
      })

      return token
    }
  } catch (error) {
    console.error('Error getting FCM token:', error)
  }
  return null
}
